import { Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Icon } from '~/global/components/icon/Icon';

export interface RightSidebarCloseButtonProps {
  onPress: () => void;
  accessibilityLabel?: string;
}

/**
 * The single close (`X`) button for the right-sidebar drawer, shared by the
 * panel header (single-tab) and the rail strip (multi-tab) so they never drift.
 * Matches the chat list's original close affordance.
 */
export const RightSidebarCloseButton = ({
  onPress,
  accessibilityLabel,
}: RightSidebarCloseButtonProps) => {
  const { t } = useTranslation('common');

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel ?? t('sidebar.close')}
      onPress={onPress}
      className="h-8 w-8 items-center justify-center rounded-lg web:hover:bg-background"
    >
      <Icon name="X" size={18} className="text-text-muted" />
    </Pressable>
  );
};
